
import { Watch, Component, Vue, Ref, PropSync, Prop, InjectReactive } from 'vue-property-decorator';
import { getStoreListApi } from "@/api/store";
import { wsSymptom, getWsStoreProductList, wsSymptomAddProduct } from "@/api/wsProduct";
import { intersectionBy, filter, map, includes } from 'lodash';

@Component({ name: 'wsProduct-components-settingTableTransfer',
})
export default class SettingTableTransfer extends Vue {
    @PropSync("visible") showTransfer !: boolean;
    @Prop({ type: Array, default: () => [] }) stashList !: Array<any>;
    @Prop({ default: true }) clearStashListFlag !: boolean;
    @Ref("transferRef") transferRef: any;

    @InjectReactive() storeId: number | string;
    @InjectReactive() symptomId: number | string;

    stashProductList = [];
    productList = [];

    mounted() {
        this.getProductList();
    }
    getProductList() {
        getWsStoreProductList({ pageNum: 1, pageSize: 200, id: this.storeId }).then((res) => {
            console.log("21212121", this.storeId)
            this.productList = res.data.list;
        });
    };

    closeTransfer() {
        this.transferRef?.clearQuery("left");
        this.transferRef?.clearQuery("right");
        if (this.clearStashListFlag) this.clearStashList();
        this.showTransfer = false;
    };

    clearStashList() {
        this.stashProductList = [];
    };

    handleTransferChange(value: any[], direction: string, movedKeys: any[]) {
        const maxSelect = 10;
        if (value.length > maxSelect) {
            this.$message.warning(`最多只能选择${maxSelect}个产品`);
            // 保留前10个，移除超出的部分
            this.stashProductList = value.slice(0, maxSelect);
        }
    };

    getStashStoreInfoList() {
        return this.stashProductList.map((item, index) => {
            const { id} = this.productList.find((store) => store.id == item) || {};
            return {
                libCode: "10001",
                productId: id,
                presId: this.symptomId,
                sortSeq: index,
                storeId: this.storeId,
            };
        });
    };

    confirmTransfer() {
        const params = {
            presSymptomId: this.symptomId,
            storeId: this.storeId,
            wsProductSymptomRelations: this.getStashStoreInfoList(),
        }
        wsSymptomAddProduct(params).then((res) => {
            this.$message.success("操作成功");
            this.closeTransfer();
            this.$emit("syncList")
        })
        // this.$emit("syncStoreList", this.stashProductList);
        // this.$emit("syncStoreInfoList", this.getStashStoreInfoList());
        // this.closeTransfer();
    };

    /**
     * 从 productList 中过滤出与 stashList id 相同的对象，并返回 id 数组
     * @returns 过滤后的 id 数组
     */
    filterStashProductList() {
        const stashListIds = map(this.stashList, 'id');
        const filteredProducts = filter(this.productList, item => includes(stashListIds, item.id));
        return map(filteredProducts, 'id');
    }

    @Watch("stashList", { deep: true })
    handleStashList(list) {
        this.stashProductList = [...list];
    }

    @Watch("showTransfer")
    handleShowTransfer(val) {
        if (this.showTransfer) {
            this.getProductList();
            this.stashProductList = this.filterStashProductList();
        }
    }

    // defineExpose({
    //     clearStashList
    // });
}
